import {
	CHILDREN_RESET,
	CHILDREN_RESET_SUCCESS,
	CHILDREN_RESET_CLEAR,
} from '../constants/patchMenu';

// « Supprimer (sites) » : l'envoi en cours, puis le bilan site par site.
const initialState = {
	busy: false,
	// null tant que rien n'a été lancé : distinct d'un bilan vide.
	results: null,
};

export default function childrenResetReducer(state = initialState, action) {
	switch (action.type) {
		case CHILDREN_RESET:
			return { busy: true, results: null };
		case CHILDREN_RESET_SUCCESS:
			return { busy: false, results: action.results };
		case CHILDREN_RESET_CLEAR:
			return initialState;
		default:
			return state;
	}
}
